import { toRefs, ref, computed } from 'vue';
import FeedBtn from './component-lib.esm4.js';
import ProfileTitle from '../title/component-lib.esm.js';
import ProfileLinkWrapper from '../component-lib.esm4.js';
import { useLink } from '../component-lib.esm6.js';
import { LINK_PROPS } from '../component-lib.esm3.js';
import StackedLayout from './layouts/component-lib.esm.js';
import { EVENTS } from '../../config/component-lib.esm.js';

//
var script = {
  components: {
    FeedBtn,
    ProfileLinkWrapper,
    ProfileTitle,
    StackedLayout
  },
  props: {
    ...LINK_PROPS,
    highlight: String
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      link
    } = toRefs(props);
    const hasSentImpression = ref(false);
    const feedOptions = computed(() => {
      return link.value.feed_options;
    });
    const showImages = computed(() => {
      return feedOptions.value.show_images;
    });
    const layout = computed(() => {
      return feedOptions.value.layout;
    });
    const itemsToShow = computed(() => {
      if (!feedOptions.value || !feedOptions.value.items) return [];
      return feedOptions.value.items.slice(0, feedOptions.value.limit);
    });
    const {
      id,
      btnProps,
      enableUtmParameters,
      utmMedium,
      utmSource
    } = useLink(props, {
      emit
    });
    function handleClick(_ref2, e) {
      let {
        id
      } = _ref2;
      emit('click', {
        item_id: id,
        ...e
      });
    }
    function handleEvent(e) {
      // Only send one impression per link
      if (e === EVENTS.IMPRESSION && hasSentImpression.value) return;
      if (e === EVENTS.IMPRESSION) hasSentImpression.value = true;
      emit('event', e);
    }
    return {
      handleClick,
      handleEvent,
      feedOptions,
      itemsToShow,
      showImages,
      layout,
      EVENTS,
      id,
      btnProps,
      enableUtmParameters,
      utmMedium,
      utmSource
    };
  }
};
export { script as default };